import { bl_applet_image_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class AppletImageHdrContainer extends BaseContainerModel {
    bl_applet_image_hdr: bl_applet_image_hdr_RowClass = new bl_applet_image_hdr_RowClass();
}
